module.exports = __webpack_public_path__ + "statics/img/bannner2.e2aee802.jpg";